const ruleUrl = "https://europe-west2-rulecat.cloudfunctions.net/rule-eval"

interface executeRuleReq {
  rule: string
}

interface executeRuleResp {
  res: any
}

export function callExecuteRule(ruleBody: string, obj: any): Promise<executeRuleResp> {
  const body: executeRuleReq = {
    rule: ruleBody,
  }

  return fetch(ruleUrl, {
    method: "POST",
    body: JSON.stringify(body),
  })
      .then(resp => resp.json())
}
